import { Box, Typography, useTheme } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { FC } from 'react';
import ImageBoxFuture from './image-box-future';
import { pxToRem } from '@/theme/typography';

const experiencesEmptyState = '/icons/experiences/experiences-empty-state.svg';

export const ExperienceEmptyState: FC = () => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Box
      component='div'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',

        mb: { tablet: pxToRem(32), mobile: '24px' },
      }}
    >
      <ImageBoxFuture
        img={experiencesEmptyState}
        title={intl.formatMessage({
          id: 'voucher_redemption.no_steps',
        })}
        objectFit='contain'
        sx={{
          mb: { tablet: pxToRem(40), mobile: '16px' },
          maxWidth: '100%',

          width: { tablet: pxToRem(567), mobile: '246px' },
          height: { tablet: pxToRem(468), mobile: '203px' },
        }}
      />

      <Typography
        component='p'
        sx={{
          fontSize: { tablet: pxToRem(20), mobile: '16px' },
          textAlign: 'center',
          color: theme.palette.grey[50],

          lineHeight: '150%',
        }}
      >
        <FormattedMessage id='experiences.empty_state' />
      </Typography>
    </Box>
  );
};
